import React from "react";
import "./style.scss";
import { Link } from "react-router-dom";
import { LinkedinOutlined, MailOutlined } from "@ant-design/icons";
import Logo from "../../../../Components/Logo";
import { footerLinkColumns, footerTagline } from "../../../../Utils/staticData";

const FooterLink = ({ label, href }) => {
  if (href.startsWith("http") || href.startsWith("mailto:")) {
    return (
      <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer">
        {label}
      </a>
    );
  }
  if (href === "#") {
    return <button className="footer-link-button">{label}</button>;
  }
  return <Link to={href}>{label}</Link>;
};

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <div className="footer" id="footer">
      <div className="footer-wrapper">
        <div className="footer-top">
          <div className="footer-brand">
            <Logo />
            <p className="footer-tagline">{footerTagline}</p>
          </div>

          <div className="footer-columns">
            {footerLinkColumns.map((column, index) => (
              <div className="footer-column" key={`col-${index}`}>
                {column.heading && <h4>{column.heading}</h4>}
                <ul>
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <FooterLink {...link} />
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <span className="footer-copyright">
            © {year} Stealth Jobs. All rights reserved.
          </span>
          <div className="footer-social">
            <a
              href="https://www.linkedin.com/company/stealth-jobs/"
              target="_blank"
              rel="noreferrer"
              className="footer-social-button"
              aria-label="LinkedIn"
            >
              <LinkedinOutlined />
            </a>
            <a
              href="mailto:support@stealthjobs.co"
              className="footer-social-button"
              aria-label="Email"
            >
              <MailOutlined />
            </a>
          </div>
          <div className="footer-bottom-links">
            <Link to="/privacy-policy" id="privacy-policy">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
